import CartSVG from "@design-system/ui-icons/vanilla/Cart"
import { createIcon } from "../createIcon"

export const CartIcon = createIcon(CartSVG)
